import type * as THREE from 'three';
import { SceneObject } from './sceneObject';
import type { SelectableObject } from './selectableObject';

export class SceneObjectCollection {
  readonly staticSceneObjects: SceneObject<any>[];
  readonly sceneObjects: SelectableObject<any>[];

  constructor(staticSceneObjects: SceneObject<any>[]) {
    this.staticSceneObjects = staticSceneObjects;
    this.sceneObjects = [];
  }

  getAll() {
    return [...this.sceneObjects, ...this.staticSceneObjects];
  }

  renderAll(parent: THREE.Scene) {
    for (const sceneObject of this.getAll()) {
      sceneObject.render(parent);
    }
  }

  updateAll(deltaSeconds: number) {
    for (const sceneObject of this.getAll()) {
      sceneObject.update(deltaSeconds);
    }
  }

  disposeAll() {
    for (const sceneObject of this.getAll()) {
      sceneObject.dispose();
    }
  }

  add(sceneObject: SelectableObject<any>) {
    this.sceneObjects.push(sceneObject);
  }

  remove(sceneObject: SelectableObject<any>) {
    const objectIndex = this.sceneObjects.indexOf(sceneObject);
    if (objectIndex === -1) {
      return false;
    }

    this.sceneObjects.splice(objectIndex, 1);
    return true;
  }

  clear() {
    for (const sceneObject of this.sceneObjects) {
      sceneObject.dispose();
    }
    this.sceneObjects.length = 0;
  }
}
